import { ReactNode } from 'react';
import NarrowHeader from 'presentations/views/components/organisms/NarrowHeader';
import NarrowFooter from 'presentations/views/components/organisms/NarrowFooter';
import Image from 'presentations/views/components/atoms/Image';
import styled from '@emotion/styled';
import { spacing, mediaMin, mediaMax } from 'presentations/views/styles';
import { blueGrayPale, primary, white } from 'presentations/views/styles/color';
import AuthBrandSlideList, {
  BrandContentMode,
} from 'presentations/views/components/organisms/AuthBrandSlideList';
import { imagePath } from 'presentations/assets';
interface Props {
  form?: ReactNode;
  snackbar?: ReactNode | null;
  headerHidden?: boolean;
  footerHidden?: boolean;
  brandContentMode?: BrandContentMode;
}
export default function Component(props: Props) {
  return (
    <>
      <MainContainer>
        {!props.headerHidden && (
          <>
            <HeaderContainer>
              <NarrowHeader />
            </HeaderContainer>
            {props.brandContentMode ? (
              <BrandContainer>
                <BrandContent>
                  <AuthBrandSlideList
                    brandContentMode={props.brandContentMode}
                  />
                </BrandContent>
              </BrandContainer>
            ) : (
              <Brand>
                <Image src="pages/login/logo_w.svg" alt="Jicoo" />
              </Brand>
            )}
          </>
        )}
        <Main>
          <MainInner>
            <Content>
              <Form>{props.form}</Form>
            </Content>
            {!props.footerHidden && (
              <Footer>
                <NarrowFooter />
              </Footer>
            )}
          </MainInner>
        </Main>
      </MainContainer>
      {props.snackbar}
    </>
  );
}

const Footer = styled.footer`
  left: 0;
  width: 100%;
  position: sticky;
  bottom: 0;
  background-color: ${white};
`;
export const HeaderContainer = styled.div`
  ${mediaMin.tablet} {
    display: none;
  }
`;
export const MainContainer = styled.div`
  min-height: 100vh;
  box-sizing: border-box;
  display: flex;
  ${mediaMax.tablet} {
    display: block;
  }
`;
const BrandContainer = styled.div`
  width: 50%;
  background: ${blueGrayPale};
  ${mediaMax.tablet} {
    display: none;
  }
`;
const BrandContent = styled.div`
  margin: 104px auto 0;
`;
const Main = styled.div`
  width: 50%;
  height: 100vh;
  overflow: auto;
  ${mediaMax.tablet} {
    width: 100%;
  }
  ${mediaMax.smartphone} {
    width: 100%;
    padding: 0 ${spacing(16)};
  }
`;
const MainInner = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  /* justify-content: center; */
  flex-direction: column;
  height: 100%;
`;
const Content = styled.div`
  ${mediaMax.smartphone} {
    width: 100%;
  }
`;

const Form = styled.div`
  margin: 0 auto;
  padding: ${spacing(16)} ${spacing(12)};
`;
const Brand = styled.div`
  width: 50%;
  /* height: 100vh; */
  background:
    linear-gradient(
      40deg,
      rgba(17, 215, 155, 0.8) 0%,
      rgba(17, 189, 215, 0.8) 20%,
      rgba(0, 84, 209, 0.8) 80%,
      rgba(142, 0, 209, 0.8) 100% ) ,
      url('${imagePath('pages/login/bg_login01.png', {})}');
  background-size: cover;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaMax.tablet} {
    display: none;
    width: 100%;
  }
`;
